import { mainAppUrl } from './appOrigin';

/** Merge tag inserted by the email builder and replaced at send time. */
export const UNSUBSCRIBE_MERGE_TAG = '{{unsubscribe_url}}';

export interface BuildUnsubscribeUrlParams {
  email: string;
  userId?: string;
  workspaceId?: string;
  campaignId?: string;
}

/**
 * RFC 8058 one-click unsubscribe endpoint (same URL as List-Unsubscribe headers).
 * Always served from the app host (app.scubamail.io), not the marketing site.
 */
export function buildUnsubscribeApiUrl(params: BuildUnsubscribeUrlParams): string {
  const qs = new URLSearchParams();
  qs.set('email', params.email);
  if (params.userId) qs.set('userId', params.userId);
  if (params.workspaceId) qs.set('workspaceId', params.workspaceId);
  if (params.campaignId) qs.set('campaignId', params.campaignId);
  return `${mainAppUrl('/api/unsubscribe-one-click')}?${qs.toString()}`;
}

/** Legacy /unsubscribe page on the app host; redirects to the API handler. */
export function buildLegacyUnsubscribePageUrl(params: BuildUnsubscribeUrlParams): string {
  const qs = new URLSearchParams();
  qs.set('email', params.email);
  if (params.userId) qs.set('userId', params.userId);
  if (params.workspaceId) qs.set('workspaceId', params.workspaceId);
  if (params.campaignId) qs.set('campaign', params.campaignId);
  return `${mainAppUrl('/unsubscribe')}?${qs.toString()}`;
}

/** Resolve footer block href: use merge tag unless merchant set a custom URL. */
export function resolveFooterUnsubscribeHref(url?: string): string {
  const trimmed = (url || '').trim();
  if (!trimmed || trimmed === '#' || trimmed === UNSUBSCRIBE_MERGE_TAG) {
    return UNSUBSCRIBE_MERGE_TAG;
  }
  return trimmed;
}

/** Replace merge tags and fix stale placeholder footer links in HTML at send time. */
export function applyUnsubscribeUrlToHtml(html: string, unsubscribeUrl: string): string {
  let result = html.split(UNSUBSCRIBE_MERGE_TAG).join(unsubscribeUrl);
  result = result.replace(
    /<a([^>]*?)href=["']#["']([^>]*?)>\s*Unsubscribe from these emails\s*<\/a>/gi,
    `<a$1href="${unsubscribeUrl}"$2>Unsubscribe from these emails</a>`
  );
  result = result.replace(
    /<a([^>]*?)href=["']#["']([^>]*?)>\s*Unsubscribe\s*<\/a>/gi,
    `<a$1href="${unsubscribeUrl}"$2>Unsubscribe</a>`
  );
  return result;
}
